export default "__VITE_ASSET__271a4fcb__"